// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by jcanales - 18/09/2023

import { ChangeDetectorRef, Component, HostListener, OnDestroy, Renderer2 } from '@angular/core'
import { BaseController } from './base.controller';
import { ADN_PLUS, Action, ApiResponseModel, CtBannerComponent, CtButtonComponent, CtContentItemComponent, CtDialogComponent, CtFormComponent, CtInputDateComponent, CtInputFileComponent, CtInputTextComponent, CtRadioComponent, CtRadioContainerComponent, CtRowComponent, CtSelectComponent, CtStepperComponent, CtStepperItemComponent, CtTabComponent, CtTableComponent, CtViewComponent, EntityField, HttpService, InputBaseComponent, breakpoints } from 'components';
import { EMPTY, Observable, Subscription, combineLatest } from 'rxjs';
import { CurrencyPipe } from '@angular/common';
import { Router } from '@angular/router';
import { defaultIfEmpty, switchMap, take } from 'rxjs/operators';

enum EstadoCargaAsociadoEnum {
    Incluido = 'C',
    Excluido = 'E'
}

enum TipoPlanillaEnum {
    Mutual = "Mutual",
    Credito = "Crédito"
}

enum TipoPresentacionEnum {
    Extraordinaria = "Extraordinaria",
    Nueva = "Nueva"
}

enum ModoPresentacion {
    Default = "DEFAULT", //aplica para ultima cargada en mutual y carga automatica en credito
    Archivo = "ARCHIVO",
    Manual = "MANUAL"
}

@Component({
    selector: 'pa-vi03',
    template: `<div [id]="getId()" #target><div>`,
    providers: [CurrencyPipe]
})

export class PaVi03 extends BaseController implements OnDestroy {

    //components
    private radioContainerMutual: CtRadioContainerComponent;
    private radioContainerCreditos: CtRadioContainerComponent;
    private stepper: CtStepperComponent;
    private mutualTableIncluidos: CtTableComponent;
    private creditosTableIncluidos: CtTableComponent;
    private mutualTableExcluidos: CtTableComponent;
    private creditosTableExcluidos: CtTableComponent;
    private inputTipoPlanilla: CtInputTextComponent;
    private incluidosTab: CtContentItemComponent;
    private excluidosTab: CtContentItemComponent;
    private addAsociadoButton: CtButtonComponent;
    private formRow: CtRowComponent;
    private confirmationStepRow: CtRowComponent;

    //util
    private tipoPlanilla: TipoPlanillaEnum;
    private estadoCargaAsociadosTab: EstadoCargaAsociadoEnum = EstadoCargaAsociadoEnum.Incluido;
    private isExtraSmall: boolean = false;
    private isSmall: boolean = false;
    private isMedium: boolean = false;
    private incluidosCount: number = 0;
    private excluidosCount: number = 0;
    private periodo: string = '';
    private totalAmount: string;
    private docIdPatrono: string;
    private numPlanilla: string;
    private tipPlanilla: string;
    private isEditing: boolean = false;
    private modoPresentacion: ModoPresentacion;
    private isAsocSearchByDocActive : boolean = false;
    private tipoPresentacion : TipoPresentacionEnum;
    private subscriptions : Subscription[] = [];
    private perCobro: number = 0;
    private data: ADN_PLUS;
    private numComprobante : string = '';

    //constants
    private readonly VALIDATION_ERROR_CODE: string = 'SWEB.WAR_MAX_VAL_ERR_PLAN_SWEB';
    private VALIDATION_SUCCESS_CODE: string = 'SWEB.INF_VAL_RESULT_PLAN_SWEB';
    private readonly ERROR_DESRIPTION: string = 'Encontramos algunos errores en el archivo importado, por favor adjunte un nuevo archivo con el formato correcto.';
    private readonly ERROR_TITLE: string = 'Errores encontrados';
    private readonly estAfterPresentacion : string = 'Cargada';

    constructor(private cdr: ChangeDetectorRef,
        private currencyPipe: CurrencyPipe,
        private renderer: Renderer2,
        private router: Router) {
        super();
        this.setViewCode('PA_VI03');
    }

    ngOnDestroy(): void {
        this.storeService.deleteAllStates();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.checkScreenSize();
    }

    private checkScreenSize() {
        const screenWidth = window.innerWidth;
        this.isMedium = screenWidth >= breakpoints.L;
        this.isSmall = screenWidth < breakpoints.L && screenWidth > breakpoints.M;
        this.isExtraSmall = screenWidth <= breakpoints.M && screenWidth > breakpoints.S;
        this.manageComponentResponsiveness();
    }

    private manageComponentResponsiveness() {
        this.manageButtonAddAsociado();
        this.manageFormContextRow();
        this.checkConfirmationStepSize();
    }

    private manageButtonAddAsociado() {
        if (!this.addAsociadoButton) return;
        const button = document.getElementById(this.addAsociadoButton.getId());
        if (!this.addAsociadoButton) return;
        if (this.isExtraSmall) {
            this.addAsociadoButton.setStyleClass('mb-3');
            this.addAsociadoButton.setBtnBlock(true);
        } else {
            this.addAsociadoButton.setStyleClass('position-absolute');
            button.setAttribute('style', 'width: 200px; z-index: 5;');
            this.addAsociadoButton.setBtnBlock(false);
        }
    }

    private manageFormContextRow() {
        if (!this.formRow) return;
        const formElement = document.getElementById(this.formRow.getId());
        if (this.isMedium) {
            this.renderer.setStyle(formElement, 'width', '35%');
            this.renderer.setStyle(formElement, 'position', 'absolute');
            this.renderer.setStyle(formElement, 'right', '100px');
            this.renderer.setStyle(formElement, 'top', '175px');
        } else if (this.isSmall) {
            this.renderer.setStyle(formElement, 'width', '30%');
            this.renderer.setStyle(formElement, 'position', 'absolute');
            this.renderer.setStyle(formElement, 'right', '30px');
            this.renderer.setStyle(formElement, 'top', '175px');
        } else {
            this.renderer.removeStyle(formElement, 'width');
            this.renderer.removeStyle(formElement, 'position');
            this.renderer.removeStyle(formElement, 'right');
            this.renderer.removeStyle(formElement, 'top');
            this.renderer.setStyle(formElement, 'width', '100%');
        }
    }

    /* ---------------------- CONTROLLER LOGIC ------------------- */

    /*
    * This function executes when the component is initialized, it checks the store service to see the type of "presentacion" that was clicked in the previous screen
    * and then it hides the radio buttons that are not needed. (Nueva & Extraodinaria).
    */
    public setOnInitState(action: Action): void {
        this.initializeComponentRefs(action);
        this.subscribeToStoreState('isEditing', (isEditing: any) => {
            if (!isEditing) {
                this.subscribeToStoreState('organizationId', (organization: string) => {
                    if (organization) this.getPatronoIdById(organization, action);
                    else this.returnToPreviousScreen();
                });
            } else {
                this.handleEditingState(action);
            }
        });
    }
    
    private initializeComponentRefs(action: Action): void {
        this.radioContainerMutual = this.utilService.getComponentRef(action.conditionParams[1]);
        this.radioContainerCreditos = this.utilService.getComponentRef(action.conditionParams[2]);
    }
    
    private handleEditingState(action: Action): void {
        this.manageHiddenProperties(action);
        this.isEditing = true;
        this.onPlanillaEdit(action);
    }

    public setAsociadoFromStore(action: Action): void {
        const input: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[0]);
        const inputPat: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[1]);
    
        this.subscribeToStoreState('tipPlanilla', (value) => {
            this.tipPlanilla = value;
            input.setValue(this.tipPlanilla);
        });
    
        this.subscribeToStoreState('docIdPatrono', (value) => {
            this.docIdPatrono = value;
            inputPat.setValue(this.docIdPatrono);
        });
    }
    
    private subscribeToStoreState(stateKey: string, action: (value: any) => void): void {
        this.storeService.getStateObservable(stateKey).pipe(
            take(1),
            defaultIfEmpty('')
        ).subscribe(action);
    }

    /**
     * This function is executed when the user clicks on the "PRESENTAR" button from the PA_VI01,
     *  this will get the patrono info based on the organiztion id
     * of the user provided on the last screen.
     */
    private getPatronoIdById(organization: string, action: Action): void {
        if (!organization) {
            this.returnToPreviousScreen();
            return;
        }
        this.retPatronoInfo(Number(organization)).subscribe({
            next: (result: ApiResponseModel) => this.handlePatronoInfoResponse(result, action)
        });
    }
    
    private handlePatronoInfoResponse(result: ApiResponseModel, action: Action): void {
        result['Data'][0]['ArrayEntities']['List'].forEach((entity: EntityField) => {
            this.processEntity(entity, action);
        });
    
        this.manageRadioStyles();
        this.setOnInitDates();
        this.manageHiddenProperties(action);
        this.setData(action);
        this.hideRadioContainerBasedOnAplDeduccionPatrono(result, action);
    }

    private hideRadioContainerBasedOnAplDeduccionPatrono(result: ApiResponseModel, action: Action) {
        const aplDeduccionPatrono = this.getAplDeduccionPatrono(result);
        if (aplDeduccionPatrono === 'N') {
            this.radioContainerCreditos.setHidden(true);
        }
    }

    private getAplDeduccionPatrono(result: ApiResponseModel) {
        const aplDeduccionPatronoEntity = result['Data'][0]['ArrayEntities']['List'].find(entity => entity.Name === 'IND_APL_DEDUCCION');
        return aplDeduccionPatronoEntity ? aplDeduccionPatronoEntity.Value : '';
    }
    
    private processEntity(entity: EntityField, action: Action): void {
        if (entity.Name === 'DOC_IDENTIFICACION') {
            this.docIdPatrono = entity.Value;
        } else if (entity.Name === 'NUM_CLIENTE') {
            const input: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[5]);
            input.setValue(entity.Value);
        }
    }

    private returnToPreviousScreen() {
        this.router.navigate(['home/view/PA_VI01']);
    }

    private manageRadioStyles(): void {
        const radiosDescriptions: NodeListOf<Element> = document.querySelectorAll('.radio-description-container');
        radiosDescriptions.forEach((radioDescription: Element) => {
            this.renderer.setStyle(radioDescription, 'width', '95%');
        });
    }

    /**
     * This function will populate the radioContainers with the dates of the last payment of the
     * patrono. (Mutual & Credito)
     */
    private setOnInitDates(): void {
        this.subscribeToPaymentDates('MUT', this.radioContainerMutual);
        this.subscribeToPaymentDates('CRE', this.radioContainerCreditos);
    }
    
    private subscribeToPaymentDates(paymentType: string, container: CtRadioContainerComponent): void {
        this.getPaymentDates(paymentType).subscribe({
          next: (result: ApiResponseModel) => {
            let data = result['Data'];
            if (data && data.length !== 0) {
                  let additionalInformation = this.getPeriodoFromResult(result);
              if (additionalInformation) {
                  container.setAdditionalInformation(additionalInformation);
              } else {
                 container.setHidden(true);
              }
            } else {
                container.setHidden(true);
            }
         },
      error: (err: any) => this.handleError(err)
      });
    }

    private setData(action: Action) {
        this.radioContainerCreditos.setAdditionalInformation(this.periodo);
        this.radioContainerMutual.setAdditionalInformation(this.periodo);
        this.inactivateNextButton(this.utilService.getComponentRef(action.conditionParams[0]));
    }

    /**
     * When the user clicks on any option inside the radio container, this function is executed.
     * @param action 
     */
    public onRadioOptionSelect(action: Action): void {
        this.enableStepperNextButton(action);

        const radioCred : CtRadioComponent = this.utilService.getComponentRef(action.actionParams[1]);
        if(radioCred.getIsChecked() && radioCred.getModelId() === 'CRED_RADIO') this.tipoPlanilla = TipoPlanillaEnum.Credito;
        else this.tipoPlanilla = TipoPlanillaEnum.Mutual;
    
        const modoArchivoSelected = this.isRadioOptionSelected(action, 1, ModoPresentacion.Archivo);
        const modoManualSelected = this.isRadioOptionSelected(action, 2, ModoPresentacion.Manual);
    
        if (modoArchivoSelected) {
            this.modoPresentacion = ModoPresentacion.Archivo;
        } else if (modoManualSelected) {
            this.modoPresentacion = ModoPresentacion.Manual;
        } else {
            this.modoPresentacion = ModoPresentacion.Default;
        }
    }
    
    private enableStepperNextButton(action: Action): void {
        const stepperItem: CtStepperItemComponent = this.utilService.getComponentRef(action.actionParams[0]);
        stepperItem.nextButtonComponent.setDisabled(false);
    }
    
    private isRadioOptionSelected(action: Action, paramIndex: number, modo: ModoPresentacion): boolean {
        const radioInput: CtRadioComponent = this.utilService.getComponentRef(action.actionParams[paramIndex]);
        return radioInput.getModelId() === modo && radioInput.getIsChecked();
    }
    
    private inactivateNextButton(stepperItem: CtStepperItemComponent) {
        stepperItem.backButtonComponent.setHidden(true);
        stepperItem.nextButtonComponent.setDisabled(true);
    }

    private manageHiddenProperties(action: Action) {
        this.setTabs(this.utilService.getComponentRef(action.conditionParams[3]));
        this.hideOptions();
    }

    private setTabs(tabComponent: CtTabComponent) {
        let contentItems: CtContentItemComponent[] = tabComponent.getChildsByType(CtContentItemComponent, true);
        this.incluidosTab = contentItems[0];
        this.excluidosTab = contentItems[1];
    }


    public checkIfPlanRevisionWarningDialogIsNeeded(action: Action): void {
        const dialog: CtDialogComponent = this.utilService.getComponentRef(action.actionParams[1]);
        this.executeValidatePlanillaPendienteRequest(this.docIdPatrono).subscribe({
            next : (response : ApiResponseModel) => {
                const tieneRevision = response['Data'][0].ArrayEntities.List.find(
                    (entity: EntityField) => entity.Name === 'IND_TIENE_REVISION').Value;
                if (tieneRevision === 'S'){
                    dialog.openDialog();
                } else {
                    const stepperItem : CtStepperItemComponent = this.utilService.getComponentRef(action.actionParams[0]);
                    const event = stepperItem.getEvent('onNextButtonAction');
                    stepperItem.executeAction2(event);
                }
            },
            error : (err : any) => {
                this.handleError(err);
            }
        });
    }

    private executeValidatePlanillaPendienteRequest(idPatrono: any): Observable<any> {
        const requestData: any = this.getValPlanPenWarningMessageRequestData(idPatrono);
        return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_VALIDATE_PLANILLA_PEN_SMS', requestData);
    }

    /*
    * Once the user selects the type of "presentacion" (Mutual or Credito) this function is executed. 
    * Saves all the necassary components to be used in the next step and sets the type of "planilla" (Mutual or Credito).
    * Hides the tables that are not needed and shows the ones that are needed. (Mutual & credito)
    * Finally it loads the count of "asociados" for each tab.
    */
    public setNextStepData(action: Action, isFileLoaded: boolean = false): void {
        const dialog : CtDialogComponent = this.utilService.getComponentRef(action.actionParams[14]);
        if(dialog) dialog.closeDialog();
        switch (this.modoPresentacion) {
            case ModoPresentacion.Archivo:
                if (isFileLoaded) this.onNextStepDataDefault(action, isFileLoaded);
                else this.onNextStepDataFile(action);
                break;

            case ModoPresentacion.Manual:
                this.onNextStepDataManual(action);
                break;

            case ModoPresentacion.Default:
                this.onNextStepDataDefault(action);
                break;
            default:
                this.onNextStepDataDefault(action);
                break;
        }
    }

    private onNextStepDataDefault(action, isFileLoaded: boolean = false): void {
        this.resetTipoPlanillaIfNotEditing();
        this.saveFirstStepComponents(action);
        this.setTipoPresentacion();
        this.setTipoPlanilla();
    
        this.subscribeToStoreState('isNewAsociado', (isNewAsociado: boolean) => {
            this.handleNextStepDataBasedOnAsociadoState(isNewAsociado, action, isFileLoaded);
        });
    }
    
    private resetTipoPlanillaIfNotEditing(): void {
        if (!this.isEditing) {
            this.tipoPlanilla = null;
        }
    }
    
    private handleNextStepDataBasedOnAsociadoState(isNewAsociado: boolean, action, isFileLoaded: boolean): void {
        if (isNewAsociado) {
            this.loadDataFromSwebWhenEditing(action);
        } else if (!this.isEditing) {
            isFileLoaded ? this.loadPlanillaAfterFileUpload(action) : this.loadDataFromSweb(action);
        } else {
            this.loadDataFromSwebWhenEditing(action);
        }
    }

    private onNextStepDataFile(action): void {
        const ctDialog: CtDialogComponent = this.utilService.getComponentRef(action.actionParams[11]);
        ctDialog.openDialog();
    }

    private onNextStepDataManual(action: Action): void {
        this.subscribeToStoreState('isNewAsociado', (isNewAsociado: boolean) => {
            if (isNewAsociado) {
                this.processNewAsociadoCase(action);
            } else {
                this.processExistingAsociadoCase(action);
            }
        });
    }
    
    private processNewAsociadoCase(action: Action): void {
        this.storeService.deleteState('isNewAsociado');
        this.loadTablesAndTab(action);
    }
    
    private processExistingAsociadoCase(action: Action): void {
        this.saveFirstStepComponents(action);
        this.setTipoPresentacion();
        this.setTipoPlanilla();
    
        const stepper: CtStepperComponent = this.utilService.getComponentRef(action.actionParams[13]);
        const event = stepper.getEvent('onManualSelected');
        if (event) {
            stepper.executeAction2(event);
        }
    } 

    private onPostActionLoadPlanillaManual(action : Action, result : ApiResponseModel): void {
        this.periodo = this.getPeriodoFromResult(null, result);
        this.stepper.changeStep(this.stepper.getCurrentIndex() + 1);
        this.storeService.deleteState('isNewAsociado');
        this.loadTablesAndTab(action);
        this.hideAddAsociadoButton(action);
        this.setFormContext(action);
        this.checkScreenSize();
    }

    private loadDataFromSwebWhenEditing(action: Action): void {
        this.subscribeToStoreState('periodoPlanilla', (periodo: string) => {
            if (periodo) this.periodo = periodo;
            this.processEditingState(action);
        });
    }
    
    private processEditingState(action: Action): void {
        this.subscribeToStoreState('isNewAsociado', (isNewAsociado: boolean) => {
            if (!isNewAsociado) {
                this.advanceToNextStep();
                const stepperItem : CtStepperItemComponent = this.utilService.getComponentRef(action.actionParams[10]);
                stepperItem.backButtonComponent.setHidden(true);
            }
            this.commonEditingTasks(action);
        });
    }
    
    private advanceToNextStep(): void {
        this.stepper.changeStep(this.stepper.getCurrentIndex() + 1);
    }
    
    private commonEditingTasks(action: Action): void {
        this.loadTablesAndTab(action);
        this.hideAddAsociadoButton(action);
        this.setFormContext(action);
        this.checkScreenSize();
    }
    
    private onPlanillaEdit(action: Action): void {
        this.initializeStepper(action);
        this.subscribeToPlanillaData();
    }
    
    private initializeStepper(action: Action): void {
        this.stepper = this.utilService.getComponentRef(action.conditionParams[4]);
    }
    
    private subscribeToPlanillaData(): void {
        const tipPlanilla$ = this.getStateObservableWithDefault('tipPlanilla', '');
        const docIdPatrono$ = this.getStateObservableWithDefault('docIdPatrono', '');
        const numPlanilla$ = this.getStateObservableWithDefault('numPlanilla', '');
    
        combineLatest([tipPlanilla$, docIdPatrono$, numPlanilla$]).subscribe({
            next: ([tipPlanilla, docIdPatrono, numPlanilla]) => {
                this.setPlanillaData(tipPlanilla, docIdPatrono, numPlanilla);
                this.executePlanillaEditViewAction();
            }
        });
    }
    
    private getStateObservableWithDefault(stateKey: string, defaultValue: any): Observable<any> {
        return this.storeService.getStateObservable(stateKey).pipe(
            take(1),
            defaultIfEmpty(defaultValue)
        );
    }
    
    private setPlanillaData(tipPlanilla: string, docIdPatrono: string, numPlanilla: string): void {
        this.tipoPlanilla = tipPlanilla.toUpperCase() === 'M' ? TipoPlanillaEnum.Mutual : TipoPlanillaEnum.Credito;
        this.docIdPatrono = docIdPatrono;
        this.numPlanilla = numPlanilla;
    }
    
    private executePlanillaEditViewAction(): void {
        const view: CtViewComponent = this.utilService.getComponentRef(this.getViewCode()).view;
        const event: Action = view.getEvent('onPlanillaEdit');
    
        this.setInputTextValue(event.conditionParams[1], this.docIdPatrono);
        this.setInputTextValue(event.conditionParams[2], this.tipoPlanilla);
        this.setInputTextValue(event.conditionParams[3], this.numPlanilla);
    
        view.executeAction2(event);
    }
    
    private setInputTextValue(componentRefParam: any, value: string): void {
        (this.utilService.getComponentRef(componentRefParam) as CtInputTextComponent).setValue(value);
    }
    
    private onStepChangeWhenEditing() {
        const step: CtStepperItemComponent = this.stepper.getChildsByType(CtStepperItemComponent, true)[0] as CtStepperItemComponent;
        const event: Action = step.getEvent('onNextButtonAction');
        this.setNextStepData(event);
    }

    /**
     * This process will be executed when the user clicks on the "Pagar" button in the last step of the stepper.
     * It's executed after the user "Cargo la planilla".
     * @param action
     */
    public loadPaymentScreen(action: Action): void {
        // this.storeService.setState('numPlanilla', 162321);
        // this.storeService.setState('docIdPatrono', this.docIdPatrono);
        // this.router.navigate(['home/view/PA_VI04']);
        this.router.navigate(['home/view/PA_VI01']);
    }

    private loadDataFromSweb(action): void {
        this.loadPlanillaFromSweb().subscribe({
            next: (result: ApiResponseModel) => this.handleLoadPlanillaSuccess(result, action),
            error: (err: any) => this.handleError(err)
        });
    }
    
    private handleLoadPlanillaSuccess(result: ApiResponseModel, action): void {
        this.periodo = this.getPeriodoFromResult(result);
        this.processIsNewAsociadoState(action);
    }

    
    
    private processIsNewAsociadoState(action): void {
        this.subscribeToStoreState('isNewAsociado', (isNewAsociado: boolean) => {
            if (!isNewAsociado) {
                this.advanceToNextStep();
            }
            this.finalizeLoadingFromSweb(action);
        });
    }
    
    private finalizeLoadingFromSweb(action): void {
        this.storeService.deleteState('isNewAsociado');
        this.loadTablesAndTab(action);
        this.hideAddAsociadoButton(action);
        this.setFormContext(action);
        this.checkScreenSize();
    }

    private loadPlanillaAfterFileUpload(action: any): void {
        this.subscribeToPaymentDateAndProcess('MUT', action);
    }
    
    private subscribeToPaymentDateAndProcess(paymentType: string, action: any): void {
        this.getPaymentDates(paymentType).subscribe({
            next: (result: ApiResponseModel) => this.handlePaymentDateSuccess(result, action),
            error: (err: any) => this.handleError(err)
        });
    }
    
    private handlePaymentDateSuccess(result: ApiResponseModel, action: any): void {
        this.periodo = this.getPeriodoFromResult(result);
        this.advanceToNextStep();
        this.finalizeLoadingAfterFileUpload(action);
    }
    
    private finalizeLoadingAfterFileUpload(action: any): void {
        this.storeService.deleteState('isNewAsociado');
        this.loadTablesAndTab(action);
        this.hideAddAsociadoButton(action);
        this.setFormContext(action);
        this.checkScreenSize();
    }
    
    private getPeriodoFromResult(result: ApiResponseModel, adnResult: any = null): string {
        const resultData = result || { Data: adnResult };
        if (!resultData['Data'] || resultData['Data'].length === 0) {
            return '';
        }
    
        return this.extractPeriodoFromData(resultData['Data'][0]['ArrayEntities']['List']);
    }
    
    private extractPeriodoFromData(entityList: EntityField[]): string {
        const periodoEntity = entityList.find(entity => entity.Name === 'FULL_PER_PAGO_DESC');
        return periodoEntity ? periodoEntity.Value : '';
    }

    public openLastStepDialog(action: Action): void {
        this.componentService.utl_openDialog(action);
        this.cdr.detectChanges();
        this.setDataToDialog(action);
    }

    private setDataToDialog(action: Action) {
        const ctDialog: CtDialogComponent = this.utilService.getComponentRef(action.actionParams[0]);
        this.setDataToDialogInputs(ctDialog.getMetaData());
    }

    private setDataToDialogInputs(metadata: any): void {
        if (!this.isValidMetadata(metadata)) {
            return;
        }
        if (metadata.ctType === 'CtInputText') {
            this.setCtInputTextData(metadata);
        } else if (this.isModelArray(metadata)) {
            metadata.models.forEach(model => this.setDataToDialogInputs(model));
        }
    }
    
    private isValidMetadata(metadata: any): boolean {
        return metadata && metadata.ctType;
    }
    
    private setCtInputTextData(metadata: any): void {
        const value = this.getValueForCtInputText(metadata.controlProperties.modelId);
        if (value !== undefined) {
            metadata.controlProperties.value = value;
        }
    }
    
    private getValueForCtInputText(modelId: string): any {
        switch (modelId) {
            case 'PERIODO':
                return this.periodo;
            case 'TIPO_PLANILLA':
                return this.inputTipoPlanilla.getValue() === 'MUT'
                    ? TipoPlanillaEnum.Mutual.toString() : TipoPlanillaEnum.Credito.toString();
            case 'TOTAL':
                return this.totalAmount;
            case 'ASOCIADOS':
                return this.incluidosCount;
            default:
                return undefined;
        }
    }
    
    private isModelArray(metadata: any): boolean {
        return metadata.models && Array.isArray(metadata.models);
    }

    public presentarPlanilla(action: Action): void {
        this.componentService.utl_closeDialog(action);
        this.stepper.changeStep(this.stepper.getCurrentIndex() + 1);
        this.cdr.detectChanges();
        this.checkConfirmationStepSize(action);
        this.setConfirmationStepData(action);
    }

    public saveNumPlanilla(action: Action, result : any) {
        const numPlanilla : string = result[0]['ArrayEntities']['List'].find(entity => entity.Name === 'NUM_PLANILLA').Value;
        this.storeService.setState('numPlanilla', numPlanilla);
        return true;
    }

    public validateNumComprobante(action: Action): boolean {
        const numComprobante = this.utilService.getComponentRef(action.actionParams[0]).getValue();
        if(numComprobante == null 
            || numComprobante == undefined
            || numComprobante === ''){
                this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', 'Por favor, ingrese el número de comprobante',
                    true, 'Aceptar', 'Cancelar');

                return false;
        }
        this.numComprobante = numComprobante;
        return true;
    }

    /*
    * This function is executed when the user clicks on the "Confirmar" button in the confirmation dialog.
    * It uses renderer because the architecture does not support Angular normal component rendering and communication. like putting
    * <ct-row></ct-row> in the template. So we have to use renderer to set the width of the row. instead of using conditional :host css
    * renderer should "NOT" be used in Angular components, but in this case we have to.
    */
    checkConfirmationStepSize(action: Action = null) {
        if (!this.confirmationStepRow && action) {
            const row: CtRowComponent = this.utilService.getComponentRef(action.actionParams[1]);
            this.confirmationStepRow = row;
        }
        if (!this.confirmationStepRow) return;
        const rowHostElement = document.getElementById(this.confirmationStepRow.getId());
        if (this.isMedium && this.isSmall) {
            this.renderer.setStyle(rowHostElement, 'width', '80%');
        } else {
            this.renderer.setStyle(rowHostElement, 'width', '95%');
        }
    }

    private setConfirmationStepData(action: Action) {
        const form: CtFormComponent = this.utilService.getComponentRef(action.actionParams[2]);
        const inputs: CtInputTextComponent[] = form.getChildsByType(CtInputTextComponent, true);
        inputs.forEach((input: CtInputTextComponent) => {
            this.setConfirmationStepDataInputs(input);
        })
    }

    private setConfirmationStepDataInputs(input: CtInputTextComponent): void {
        const modelId = input.getModelId();
        const value = this.getValueForInput(modelId);
        input.setValue(value);
    
        if (modelId === 'EST_PLANILLA') {
            this.setStyleForEstPlanilla(input);
        }
    }
    
    private getValueForInput(modelId: string): string {
        switch (modelId) {
            case 'PERIODO':
                return this.periodo;
            case 'TIPO_PLANILLA':
                return this.tipoPlanilla;
            case 'TOTAL':
                return this.totalAmount;
            case 'ASOCIADOS':
                return `${this.incluidosCount} de ${this.incluidosCount + this.excluidosCount}`;
            case 'EST_PLANILLA':
                return this.estAfterPresentacion;
            default:
                return '';
        }
    }
    
    private setStyleForEstPlanilla(input: CtInputTextComponent): void {
        const inputComponentElement = document.getElementById(input.getId());
        if (inputComponentElement) {
            const inputElement = inputComponentElement.querySelector('input');
            if (inputElement) {
                inputElement.style.setProperty('color', 'red', 'important');
            }
        }
    }

    private checkStepperItemAsoc(action: Action): void {
        const stepperItem = this.getStepperItemFromAction(action);
        this.setStepperItemButtonState(stepperItem, this.incluidosCount === 0);
    }
    
    private getStepperItemFromAction(action: Action): CtStepperItemComponent {
        const paramIndex = action.actionParams[10] ? 10 : 1;
        return this.utilService.getComponentRef(action.actionParams[paramIndex]);
    }
    
    private setStepperItemButtonState(stepperItem: CtStepperItemComponent, isDisabled: boolean): void {
        stepperItem.nextButtonComponent.setDisabled(isDisabled);
    }

    private setFormContext(action: Action) {
        let form: CtFormComponent = this.utilService.getComponentRef(action.actionParams[8]);
        this.formRow = this.utilService.getComponentRef(action.actionParams[9]);
        const inputs: CtInputTextComponent[] = form.getChildsByType(CtInputTextComponent, true);
        const inputPeriodo: CtInputTextComponent = inputs[0];
        const inputTipo: CtInputTextComponent = inputs[1];
        inputTipo.setValue(this.inputTipoPlanilla.getValue() === 'MUT' ? TipoPlanillaEnum.Mutual.toString() : TipoPlanillaEnum.Credito.toString());
        inputPeriodo.setValue(this.periodo);
    }

    private hideAddAsociadoButton(action: Action) {
        this.addAsociadoButton = this.utilService.getComponentRef(action.actionParams[7]);
        if (this.tipoPlanilla == TipoPlanillaEnum.Mutual) this.addAsociadoButton.setHidden(false);
        else this.addAsociadoButton.setHidden(true);
    }

    private saveFirstStepComponents(action: Action) {
        this.stepper = this.utilService.getComponentRef(action.actionParams[0]);
        this.mutualTableIncluidos = this.utilService.getComponentRef(action.actionParams[1]);
        this.creditosTableIncluidos = this.utilService.getComponentRef(action.actionParams[2]);
        this.inputTipoPlanilla = this.utilService.getComponentRef(action.actionParams[3]);
        this.mutualTableExcluidos = this.utilService.getComponentRef(action.actionParams[5]);
        this.creditosTableExcluidos = this.utilService.getComponentRef(action.actionParams[6]);
    }

    private loadTablesAndTab(action: Action) {
        this.loadIncluidosTable(action);
        this.loadExcluidosTable(action);
    }

    private loadIncluidosTable(action: Action): void {
        this.getAsociadosPlanilla("", EstadoCargaAsociadoEnum.Incluido).subscribe({
            next: (response: ApiResponseModel) => this.handleIncluidosResponse(response, action),
            error: (err: any) => this.handleError(err)
        });
    }
    
    private handleIncluidosResponse(response: ApiResponseModel, action: Action): void {
        const data = response['Data'];
        this.setAdnToComponentBasedOnTipoPlanilla(data, action, { mutualIndex: 1, creditoIndex: 2 });
        this.setTotalAmountAndAsociadosCount(action);
    }

    private setTotalAmountAndAsociadosCount(action: Action): void {
        this.executeRetPresPlanillaDetInfoRequest(action);
    }
    
    private getRetPresPlanillaDetInfoResults(response: ApiResponseModel) {
        const totalAmount: string = response['Data'][0]['ArrayEntities']['List'].find(entity => {
            return entity.Name === 'MONTO_TOTAL';
        }).Value;

        const totalIncluidos: string = response['Data'][0]['ArrayEntities']['List'].find(entity => {
            return entity.Name === 'TOTAL_INCLUIDO';
        }).Value;

        const totalExcluidos: string = response['Data'][0]['ArrayEntities']['List'].find(entity => {
            return entity.Name === 'TOTAL_EXCLUIDO';
        }).Value;

        return { totalAmount, totalIncluidos, totalExcluidos };
    }

    private handleError(err: any): void {
        this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
            true, 'Aceptar', 'Cancelar');
    }

    private setTotalAmount(amount : string, action: Action): void {
        if(!amount) return;
        const stepperItem = this.getStepperItemComponent(action);
        this.updateTotalAmount(Number(amount));
        this.setStepperFooterDescription(stepperItem, amount.toString());
    }
    
    private getStepperItemComponent(action: Action): CtStepperItemComponent {
        return this.utilService.getComponentRef(action.actionParams[10]) || this.utilService.getComponentRef(action.actionParams[1]);
    }
    
    private updateTotalAmount(sum: number): void {
        this.totalAmount = this.currencyPipe.transform(sum, '₡', 'symbol', '1.0-2').toString() + '.00';
    }
    
    private setStepperFooterDescription(stepperItem: CtStepperItemComponent, description: string): void {
        if (stepperItem) {
            stepperItem.setFooterDescriptionValue(description);
        }
    }
    
    private loadExcluidosTable(action: Action): void {
        this.getAsociadosPlanilla("", EstadoCargaAsociadoEnum.Excluido).subscribe({
            next: (response: ApiResponseModel) => this.handleExcluidosResponse(response, action),
            error: (err: any) => this.handleError(err)
        });
    }
    
    private handleExcluidosResponse(response: ApiResponseModel, action: Action): void {
        const data = response['Data'];
        this.setAdnToComponentBasedOnTipoPlanilla(data, action, { mutualIndex: 5, creditoIndex: 6 });
        this.setTotalAmountAndAsociadosCount(action);
    }

    private setAdnToComponentBasedOnTipoPlanilla(data: any, action: Action, paramsIndex: { mutualIndex: number, creditoIndex: number }): void {
        const componentRefParam = this.tipoPlanilla == TipoPlanillaEnum.Mutual 
                                  ? action.actionParams[paramsIndex.mutualIndex] 
                                  : action.actionParams[paramsIndex.creditoIndex];
        this.utilService.setAdnToAnyComponent(componentRefParam, data);
    }
    
    private setTabCount(length: any, est_carga_asoc: EstadoCargaAsociadoEnum, action: Action) {
        if (est_carga_asoc === EstadoCargaAsociadoEnum.Incluido) {
            this.incluidosTab.setTitleComplement(length);
            this.incluidosCount = Number(length);
        } else {
            this.excluidosTab.setTitleComplement(length);
            this.excluidosCount = Number(length);
        }
        this.checkStepperItemAsoc(action);
    }

    private setTipoPlanilla(): void {
        if (this.tipoPlanilla == TipoPlanillaEnum.Mutual) {
            this.inputTipoPlanilla.setValue('MUT');
            this.mutualTableIncluidos.setHidden(false);
            this.mutualTableExcluidos.setHidden(false);
            this.creditosTableIncluidos.setHidden(true);
            this.creditosTableExcluidos.setHidden(true);
        } else {
            this.inputTipoPlanilla.setValue('CRE');
            this.mutualTableIncluidos.setHidden(true);
            this.mutualTableExcluidos.setHidden(true);
            this.creditosTableIncluidos.setHidden(false);
            this.creditosTableExcluidos.setHidden(false);
        }
    }

    private setTipoPresentacion(): void {
        if (this.tipoPlanilla) return;
    
        this.tipoPlanilla = this.getCheckedTipoFromRadioContainer(this.radioContainerMutual, TipoPlanillaEnum.Mutual)
                          || this.getCheckedTipoFromRadioContainer(this.radioContainerCreditos, TipoPlanillaEnum.Credito);
    }
    
    private getCheckedTipoFromRadioContainer(container: CtRadioContainerComponent, tipo: TipoPlanillaEnum): TipoPlanillaEnum | null {
        const checkedRadio = container.getChildsByType(CtRadioComponent, true)
                                      .find((child: CtRadioComponent) => child.getIsChecked());
        return checkedRadio ? tipo : null;
    }

    private hideOptions(): void {
        this.subscribeToStoreState('tipoPresentacion', (state: TipoPresentacionEnum) => {
            if (state === TipoPresentacionEnum.Extraordinaria) {
                this.hideRadioComponents();
            }
        });
    }
    
    private hideRadioComponents(): void {
        const childrenMutu = this.getChildrenRadioComponents(this.radioContainerMutual);
        const childrenCred = this.getChildrenRadioComponents(this.radioContainerCreditos);
        const children = childrenMutu.concat(childrenCred);
    
        children.forEach((child: CtRadioComponent) => child.setHidden(true));
    }
    
    private getChildrenRadioComponents(container: CtRadioContainerComponent): CtRadioComponent[] {
        return container ? container.getChildsByType(CtRadioComponent, true) : [];
    }

    public searchIncluidos(action: Action): void {
        this.searchAsociados(action, EstadoCargaAsociadoEnum.Incluido, this.mutualTableIncluidos, this.creditosTableIncluidos);
    }
    
    public searchExcluidos(action: Action): void {
        this.searchAsociados(action, EstadoCargaAsociadoEnum.Excluido, this.mutualTableExcluidos, this.creditosTableExcluidos);
    }
    
    private searchAsociados(action: Action, estadoCarga: EstadoCargaAsociadoEnum, mutualTable: CtTableComponent, creditosTable: CtTableComponent): void {
        const inputTextInput: CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[0]);
        this.getAsociadosPlanilla(inputTextInput.getValue(), estadoCarga).subscribe({
            next: (response: ApiResponseModel) => {
                this.executeRetPresPlanillaDetInfoRequest(action);
                const table = this.tipoPlanilla 
                    == TipoPlanillaEnum.Mutual ? mutualTable : creditosTable;
                this.utilService.setAdnToAnyComponent(table.getId(), response['Data']);
            }
        });
    }
    
    private executeRetPresPlanillaDetInfoRequest(action: Action) {
        this.retPresPlanillaDetInfo(this.inputTipoPlanilla.getValue()).subscribe({
            next: (response: ApiResponseModel) => {
                const { totalAmount, totalIncluidos, totalExcluidos } = this.getRetPresPlanillaDetInfoResults(response);
                this.setTotalAmount(totalAmount, action);
                this.setTabCount(totalIncluidos, EstadoCargaAsociadoEnum.Incluido, action);
                this.setTabCount(totalExcluidos, EstadoCargaAsociadoEnum.Excluido, action);
            },
            error: (err: any) => this.handleError(err)
        });
    }

    /**
     * This function is executed when the user clicks on the "Incluir" button inside the dialog of "Incluir asociado" at the second step.
     */
    public addAsociado(action: Action): void {
        const tab: CtTabComponent = this.utilService.getComponentRef(action.conditionParams[0]);
        const button: CtButtonComponent = this.utilService.getComponentRef(action.conditionParams[1]);
        const tabs: CtContentItemComponent[] = tab.getChildsByType(CtContentItemComponent, true);
    
        this.prepareToAddAsociado();
    
        if (this.isFirstTabSelected(tabs, tab)) {
            button.event2('onClickAddAsocs');
        } else if (this.isSecondTabSelected(tabs, tab)) {
            if (this.validateAndProceedSecondTab(tabs[1], button)) return;
        }
    }

    public afterIncluirAsociado(action: Action): void {
        const form : CtFormComponent = this.utilService.getComponentRef(action.actionParams[0]);
        const formInputChildren : InputBaseComponent[] = form.getFormElements();
        formInputChildren.forEach((child: InputBaseComponent) => {
            child.setReadOnly(false);
        });
        form.cleanForm();
    }

    public validateIncluirTableBeforeInclude(action : Action): boolean {
        const table: CtTableComponent = this.utilService.getComponentRef(action.actionParams[0]);
        if(table.getSelectedAdns() === null ||
            table.getSelectedAdns() === undefined ||
            table.getSelectedAdns().length === 0) return false;
        return true;
    }
    
    private prepareToAddAsociado(): void {
        this.storeService.setState('isNewAsociado', true);
        this.modoPresentacion = ModoPresentacion.Default;
    }
    
    private isFirstTabSelected(tabs: CtContentItemComponent[], tab: CtTabComponent): boolean {
        return tabs[0].getId() === tab.getSelectedTab().getId();
    }
    
    private isSecondTabSelected(tabs: CtContentItemComponent[], tab: CtTabComponent): boolean {
        return tabs[1].getId() === tab.getSelectedTab().getId();
    }
    
    private validateAndProceedSecondTab(tabContent: CtContentItemComponent, button: CtButtonComponent): boolean {
        const form: CtFormComponent = tabContent.getChildsByType(CtFormComponent, true)[0] as CtFormComponent;
        if (!this.validateNewAsociadoForm(form)) {
            return true;
        }
        button.event2('onClickCreateAsocs');
        return false;
    }

    // Validaciones
    private validateNewAsociadoForm(form: CtFormComponent): boolean {
        const formElements: InputBaseComponent[] = form.getFormElements();

        for (let element of formElements) {
            if (element instanceof InputBaseComponent) {
                if (this.isFieldEmpty(element)) {
                    this.messageValidationForm('Por favor, complete todos los campos obligatorios antes de enviar el formulario. Los campos marcados con * son requeridos.');
                    return false;
                } else {
                    if (!this.validateField(element)) {
                        return false;
                    }
                }
            }
        }
        return true;
    }
    
    private isFieldEmpty(element: InputBaseComponent): boolean {
        if(element.getCtType() === 'CtInputNumber' &&  element.getValue() === null) {
            return element.getOldValue() === '';
        }else{
            return element.getValue() === '' || element.getValue() === null;
        }
    }

    private validateField(element: InputBaseComponent): boolean {
        switch (element.getModelId()) {
            case 'DOC_IDENTIFICACION':
                if (element.getValue().length <= 8) {
                    this.messageValidationForm('El dato ingresado para el número de identificación parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.');
                    return false;
                }
                break;
            case 'FEC_NACIMIENTO':
                if (!this.validationDate(element)) {
                    this.messageValidationForm('El dato ingresado para la fecha de nacimiento parece incorrecto. Por favor, revise y corrija este dato para continuar.');
                    return false;
                }
                break;
            case 'CORREO':
                if (!this.validationEmail(element)) {
                    this.messageValidationForm('El dato ingresado para correo electrónico institucional parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.');
                    return false;
                }
                break;
            case 'TELEFONO':
                if (element.getValue().length < 8) {
                    this.messageValidationForm('El dato ingresado para teléfono institucional parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.');
                    return false;
                }
                break;    

            case 'MON_DEDUCIDO':
                if (element.getOldValue() <= 0 ) {
                    this.messageValidationForm('El monto deducido debe ser mayor a cero, si se desea eliminar por medio del botón de excluir en la tabla.');
                    return false;
                }
                break;    
        }
        return true;
    }



  private messageValidationForm(message): void {
    this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', message ,true, 'Aceptar', 'Cancelar');
  }

  private validationEmail(element): boolean{
  const pattern: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(pattern.test(element.getValue())){
      return true;
    }else return false;
  }

  private validationDate(element): boolean{
    let fechaString = element.getValue();
        const year = parseInt(fechaString.substr(0, 4), 10);
        const month = parseInt(fechaString.substr(4, 2), 10) - 1;
        const day = parseInt(fechaString.substr(6, 2), 10);
        const fecha = new Date(year,month,day);
        const fechaActual = new Date();
        const diferenciaEnAnios = fechaActual.getFullYear() - fecha.getFullYear();
        if (diferenciaEnAnios > 100 || diferenciaEnAnios < 15) {
          return false;
        } else {
          return true;
        }
  }

    private validatePlanillaFile(action: Action): void {
        const input: CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[0]);
        input.setValue('MUT');
        const inputFile: CtInputFileComponent = this.utilService.getComponentRef(action.actionParams[1]);
        this.executePlanillaFileValidation(input, inputFile, action);
    }

    private executePlanillaFileValidation(input: CtInputTextComponent, inputFile: CtInputFileComponent, action: Action): void {
        this.validatePlanillaFileRequest(inputFile, input).subscribe({
            next: (result: ApiResponseModel) => {
                this.manageFileValidationResult(result, action);
            },
            error: (error: any) => {
                this.handleError(error);
            }
        });
    }

    private manageFileValidationResult(result: ApiResponseModel, action: Action): void {
        const messageCode = result['ResponseMessages'][0].MessageCode;
    
        if (messageCode === this.VALIDATION_ERROR_CODE) {
            this.handleValidationError(result, action);
        } else if (messageCode === this.VALIDATION_SUCCESS_CODE) {
            this.handleValidationSuccess(result, action);
        }
    }
    
    private handleValidationError(result: ApiResponseModel, action: Action): void {
        const dialog: CtDialogComponent = this.utilService.getComponentRef(action.actionParams[3]);
        const inputFile: CtInputFileComponent = this.utilService.getComponentRef(action.actionParams[1]);
        const table: CtTableComponent = this.utilService.getComponentRef(action.actionParams[2]);
        table.setHidden(false);
        this.manageFileValidationErrors(result, dialog, inputFile, table);
    }
    
    private handleValidationSuccess(result: ApiResponseModel, action: Action): void {
        const table: CtTableComponent = this.utilService.getComponentRef(action.actionParams[2]);
        this.utilService.setAdnToAnyComponent(table.getId(), result['Data']);
        table.setSelectedAdn(result['Data'][0]);
    
        const successDialog: CtDialogComponent = this.utilService.getComponentRef(action.actionParams[4]);
        const errorDialog: CtDialogComponent = this.utilService.getComponentRef(action.actionParams[3]);
        successDialog.openDialog();
        errorDialog.closeDialog();
    }

    private manageFileValidationErrors(result: ApiResponseModel, dialog: CtDialogComponent, inputFile: CtInputFileComponent, table: CtTableComponent) {
        dialog.setWidth(1000);
        dialog.setDescription(this.ERROR_DESRIPTION);
        dialog.setTitle(this.ERROR_TITLE);
        inputFile.onButtonInputClear();
        this.utilService.setAdnToAnyComponent(table.getId(), result['Data']);
    }

    private onPlanillaLoaded(action: Action): void {
        const dialog: CtDialogComponent = this.utilService.getComponentRef(action.actionParams[0]);
        dialog.closeDialog();
        const stepperItem: CtStepperItemComponent = this.utilService.getComponentRef(action.actionParams[1]);
        let event: Action = stepperItem.getEvent('onNextButtonAction');
        this.setNextStepData(event, true);
    }

    private enableValidateButton(action: Action): void {
        const button: CtButtonComponent = this.utilService.getComponentRef(action.actionParams[0]);
        button.setDisabled(false);
    }

    private disableValidateButton(action: Action): void {
        const button: CtButtonComponent = this.utilService.getComponentRef(action.actionParams[0]);
        button.setDisabled(true);
    }

    private getAsociadosRequest(tip_planilla: string, est_registro: string, search_data: string): any {
        return {
            "Type": 1,
            "UserCode": "SVA",
            "Source": "SVA",
            "Conditions":
            {
                "Data": [
                    {
                        "Name": "ID_DOC_PATRONO",
                        "Alias": "ID_DOC_PATRONO",
                        "Value": this.docIdPatrono
                    },
                    {
                        "Name": "TIP_PLANILLA",
                        "Alias": "TIP_PLANILLA",
                        "Value": tip_planilla
                    },
                    {
                        "Name": "EST_REGISTRO",
                        "Alias": "EST_REGISTRO",
                        "Value": est_registro
                    },
                    {
                        "Name": "ID_OR_NAME",
                        "Alias": "ID_OR_NAME",
                        "Value": search_data
                    }
                ]
            },
            "Data": []
        }
    }

    private getPlanillaFromSwebRequest(tip_planilla: string): any {
        return {
            "Type": 1,
            "UserCode": "SVA",
            "Source": "SVA",
            "Conditions":
            {
                "Data": [
                    {
                        "Name": "DOC_IDENTIFICACION",
                        "Alias": "DOC_IDENTIFICACION",
                        "Value": this.docIdPatrono
                    },
                    {
                        "Name": "TIP_PLANILLA",
                        "Alias": "TIP_PLANILLA",
                        "Value": tip_planilla
                    },
                    {
                        "Name": "PM_VI00",
                        "Alias": "PM_VI00",
                        "Value": this.getViewCode()
                    }
                ]
            },
            "Data": []
        }
    }

    private getValidatePlanillaFileRequestData(inputFile: CtInputFileComponent, tipPlanillaInput: CtInputTextComponent): any {
        return {
            "Type": 0,
            "UserCode": this.loggedUser.user.user_code,
            "Source": "SVA",
            "Conditions":
            {
                "Data": [
                    {
                        "Name": "TIP_PLANILLA",
                        "Alias": "TIP_PLANILLA",
                        "Value": tipPlanillaInput.getValue()
                    }
                ]
            },
            "Data": [{
                "ID": "AABC3yAAZAAAcNOAAP",
                "ArrayEntities": {
                    "List": [
                        {
                            "Name": "DUMMY",
                            "Alias": "DUMMY",
                            "Value": "0",
                            "Display": "DUMMY",
                            "Type": 1,
                            "TypeInt": 1,
                            "FamilyId": null
                        }
                    ]
                },
                "Entity": 145,
                "EntityInt": 145,
                "Auditable": false,
                "PCID": null
            }],
            "Files": [...inputFile.getProcessedFiles()]
        }
    }

    private getPatronoInfoRequestData(organizationId: number): any {
        return {
            "Type": 1,
            "UserCode": "SVA",
            "Source": "SVA",
            "Conditions":
            {
                "Data": [
                    {
                        "Name": "NUM_CLIENTE_PAT",
                        "Alias": "NUM_CLIENTE_PAT",
                        "Value": organizationId
                    },
                    {
                        "Name": "NOM_COMPLETO",
                        "Alias": "NOM_COMPLETO",
                        "Value": ''
                    }
                ]
            },
            "Data": []
        }
    }

    private buildContRequest(docIdentificacionValue: string): any {
        return {
            "Type": 1,
            "UserCode": "SVA",
            "Source": "SVA",
            "Conditions": {
                "Data": [{
                    "Name": "DOC_IDENTIFICACION",
                    "Alias": "DOC_IDENTIFICACION",
                    "Value": docIdentificacionValue,
                    "Display": "",
                    "Type": 1,
                    "FamilyId": ""
                }]
            },
            "Data": [],
            "Files": []
        };
    }

    public getAsociadosPlanilla(inputTextInput: string, est_registro: string): Observable<any> {
        const requestData: any = this.getAsociadosRequest(this.inputTipoPlanilla.getValue(), est_registro, inputTextInput);
        return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_RET_CARGA_ASOCIADOS_SVA', requestData);
    }

    public loadPlanillaFromSweb(): Observable<any> {
        const requestData: any = this.getPlanillaFromSwebRequest(this.inputTipoPlanilla.getValue());
        return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_CARGA_PLANILLA_WEB_2', requestData);
    }

    public getPaymentDates(tip_planilla: string): Observable<any> {
        const requestData: any = this.getPlanillaFromSwebRequest(tip_planilla);
        requestData.Conditions.Data[1].Value = tip_planilla;
        return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_RET_PERIODO_PLAN_MUT_CRED_PR', requestData);
    }

    public retPatronoInfo(organizationId: number): Observable<any> {
        const requestData: any = this.getPatronoInfoRequestData(organizationId);
        return this.httpService.post(HttpService.ENDPOINT + '/api/process/CLIENTE/RET_CLIENTES_PATRONOS', requestData);
    }

    public retPresPlanillaDetInfo(tipPlanilla : string): Observable<any> {
        const requestData: any = this.getAsociadosRequest(tipPlanilla,null,null);
        return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_RET_PRES_PLANILLA_DET_INFO', requestData);
    }

    public validatePlanillaFileRequest(inputFile: CtInputFileComponent, tipPlanillaInput: CtInputTextComponent): Observable<any> {
        return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_VALIDAR_PLAN_SWEB',
            this.getValidatePlanillaFileRequestData(inputFile, tipPlanillaInput));
    }

    public fillFormWithData(action: Action) {
        let input: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[0]);
        let form: CtFormComponent = this.utilService.getComponentRef(action.conditionParams[1]);
    
        this.setADN(input, form);
      }
    
      public setADN(doc_identificacion: CtInputTextComponent, form: CtFormComponent) {
    
        let contRequest = {
          "Type": 1,
          "UserCode": "SVA",
          "Source": "SVA",
          "Conditions":
          {
            "Data": [{
              "Name": "DOC_IDENTIFICACION",
              "Alias": "DOC_IDENTIFICACION",
              "Value": doc_identificacion.getValue(),
              "Display": "",
              "Type": 1,
              "FamilyId": ""
            },
            ]
          },
          "Data": [],
          "Files": []
        }
    
        if (doc_identificacion) {
    
          this.httpService.post(HttpService.ENDPOINT + '/api/process/CLIENTE_CL/SER_RET_DATA_BY_DOC_IDENTIFICACION', contRequest).subscribe({
            next: (response: ApiResponseModel) => {
              this.setFormAvailability(form, response['Data']);
    
            },
            error: (error: any) => {
    
            }
    
          });
        }
    
      }
    

    private setFormAvailability(form, response: any): void {
        const elements = form.getFormElements();
    
        elements.forEach(element => {
            const newValue = response && response.length > 0
                ? this.utilService.getStringAttribute(element.getModelId(), response[0].ArrayEntities.List)
                : null;
    
            element.setValue(newValue);
            element.readOnly = this.isReadOnlyElement(element.modelId, newValue);
            if(element instanceof CtSelectComponent){
                element.formControl.nativeElement.disabled = this.isReadOnlyElement(element.getModelId(), newValue);
            }
        });
        this.isAsocSearchByDocActive = true;
    }
    
    private isReadOnlyElement(modelId: string, value: any): boolean {
        const readOnlyModelIds = ['NOM_ASOCIADO', 'NOM_APELLIDO1', 'NOM_APELLIDO2', 'FEC_NACIMIENTO', 'TIP_IDENTIFICACION'];
        return readOnlyModelIds.includes(modelId) && value != null;
    }

    public setSummary(action: Action) {
        let periodo: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[0]);
        let tipPlanilla: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[1]);
        let total: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[2]);
        let monto: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[3]);

        let tipPlanillaCons: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[4]);

        periodo.setValue(this.periodo);
        total.setValue(this.incluidosCount);
        monto.setValue(this.totalAmount);
        tipPlanilla.setValue(tipPlanillaCons.getValue().toUpperCase() === 'MUT' ? TipoPlanillaEnum.Mutual : TipoPlanillaEnum.Credito);
      }

    public changeAsocState():boolean {
        this.prepareToAddAsociado(); /* Cambiar nombre a este método algo más genérico  */
        return true;
    }  

    public onDocIdInputChange(action : Action): void {
        if (this.isAsocSearchByDocActive) {
            const form: CtFormComponent = this.utilService.getComponentRef(action.conditionParams[0]);
            const elements = form.getFormElements();
            elements.forEach(element => {
              element.setReadOnly(false);
              if(element.getModelId() !== 'DOC_IDENTIFICACION' ) element.setValue('');
              if (element instanceof CtSelectComponent) {
                element.formControl.nativeElement.disabled = false;
                element.cleanComponentSelection();
              }
              if(element instanceof CtInputDateComponent) {
                element.setValue('');
                element.formControl.nativeElement.value = '';
                element.formControl.nativeElement.disabled = false;
              }
            });
          }
          this.isAsocSearchByDocActive = false;
      }

      public validateFormEdit(action: Action): boolean {
        let form: CtFormComponent = this.utilService.getComponentRef(action.actionParams[0]);
        let elements = form.getFormElements();
        let value = true;
        value = this.formValidation(elements);
        return value;
      }
    
      private formValidation(elements): boolean {
        for (let element of elements) {
            if (element instanceof InputBaseComponent) {
               if (this.isFieldEmpty(element)) {
                    this.messageValidationForm('Por favor, complete todos los campos obligatorios antes de enviar el formulario. Los campos marcados con * son requeridos.');
                    return false;
                } else {
                    if (!this.validateField(element)) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    public setFormAsociado(action: Action) {
        let tableAsociados: CtTableComponent = this.utilService.getComponentRef(action.actionParams[0]);
        let formAsociados: CtFormComponent = this.utilService.getComponentRef(action.actionParams[1]);

        let data = tableAsociados.getSelectedAdn()
        this.utilService.setAdnToAnyComponent(action.actionParams[1], data);

      }




    public updateMontosAsoc(action: Action) {
          let tableAsociados: CtTableComponent = this.utilService.getComponentRef(action.actionParams[0]);
          let tipPlanillaInput: CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[1]);
          let formAsociados: CtFormComponent = this.utilService.getComponentRef(action.actionParams[2]);
          let estRegistro: CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[3]);

  

      
          this.updateMontos(tableAsociados, tipPlanillaInput,formAsociados,estRegistro).subscribe({
            next: (response: ApiResponseModel) => {
              let data = response['Data']
              this.utilService.setAdnToAnyComponent(action.actionParams[2], response['Data']);
            },
            error: (err: any) => {
              this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
                true, 'Aceptar', 'Cancelar');
            }
          });
       }
  
        
    private setUpdateMontosAsocMetadata(tableAsociados : CtTableComponent, tipPlanillaInput : CtInputTextComponent, formAsociados: CtFormComponent, estRegistro: CtInputTextComponent): any {
  
        return {
        "Type": 1,
        "UserCode": "SVA",
        "Source": "SVA",
        "Conditions":
        {
            "Data": [
            
            {
                "Name": "DOC_IDENTIFICACION",
                "Alias": "DOC_IDENTIFICACION",
                "Value":  tableAsociados.getSelectedAdn().getStringAttribute('DOC_IDENTIFICACION')

            },
            {
                "Name": "TIP_PLANILLA",
                "Alias": "TIP_PLANILLA",
                "Value": tipPlanillaInput.getValue()
            },
            {
                "Name": "EST_REGISTRO",
                "Alias": "EST_REGISTRO",
                "Value": estRegistro.getValue()
            },
            {
                "Name": "MON_DEDUCIDO",
                "Alias": "MON_DEDUCIDO",
                "Value":  formAsociados.getFormElementByModelId('MON_RECIBIDO').getValue()
            },
            {
                "Name": "MON_COBRADO",
                "Alias": "MON_COBRADO",
                "Value":  tableAsociados.getSelectedAdn().getStringAttribute('MON_COBRADO')
            },
            {
                "Name": "DOC_ID_PAT",
                "Alias": "DOC_ID_PAT",
                "Value":    tableAsociados.getSelectedAdn().getStringAttribute('DOC_ID_PAT')
            }

            ]
        },
        "Data": []
        }
    }

    private getValPlanPenWarningMessageRequestData(idPatrono: any): any {
        return {
          "Type": 1,
          "UserCode": "SVA",
          "Source": "SVA",
          "Conditions": {
            "Data": [
              {
                "Name": "DOC_IDENTIFICACION",
                "Alias": "DOC_IDENTIFICACION",
                "Value": idPatrono
              },
              {
                "Name": "TIP_PLANILLA",
                "Alias": "TIP_PLANILLA",
                "Value":  this.tipoPlanilla == TipoPlanillaEnum.Mutual ? 'MUT' : 'CRE'
              },
              {
                "Name": "PM_VI00",
                "Alias": "PM_VI00",
                "Value": "PA_VI03"
              }
            ]
          },
          "Data": [],
          "Params": null
        }
    }
  
    public updateMontos(tableAsociados : CtTableComponent, tipPlanillaInput : CtInputTextComponent, formAsociados : CtFormComponent, estRegistro : CtInputTextComponent): Observable<any> {
        const requestData: any = this.setUpdateMontosAsocMetadata(tableAsociados, tipPlanillaInput,formAsociados,estRegistro);
        return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_UPD_DET_PLAN_WEB', requestData);
    }

    public setTableAccesos(action: Action) {
        let tableAccesos: CtTableComponent = this.utilService.getComponentRef(action.conditionParams[0]);
        let userId: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[1]).getValue();
        let organization: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[2]).getValue();
    

        this.subscriptions.push(this.getAccesos(userId, organization).subscribe({
          next: (response: ApiResponseModel) => {
            this.utilService.setAdnToAnyComponent(action.conditionParams[0], response['Data']);
          },
          error: (err: any) => {
            this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
              true, 'Aceptar', 'Cancelar');
          }
        }));
      }

      public getAccesos(userId: CtInputTextComponent, organization: CtInputTextComponent): Observable<any> {
        const requestData: any = this.setTableAccesosMetadata(userId, organization);
        return this.httpService.post(HttpService.ENDPOINT + '/api/process/USER/SER_RET_ACCESOS_ADMIN', requestData);
      }



      private setTableAccesosMetadata(userId: CtInputTextComponent, organization: CtInputTextComponent): any {


        return {
          "Type": 1,
          "UserCode": "SVA",
          "Source": "SVA",
          "Conditions":
          {
            "Data": [
              {
                "Name": "ORGANIZATION",
                "Alias": "ORGANIZATION",
                "Value": Number(organization)
    
              },
              {
                "Name": "USER_ID",
                "Alias": "USER_ID",
                "Value": userId
              },
              {
                "Name": "ROL_ADMIN",
                "Alias": "ROL_ADMIN",
                "Value": "N"
    
              },
              {
                "Name": "ROL_PLANI",
                "Alias": "ROL_PLANI",
                "Value": "N"
    
              },
              {
                "Name": "ROL_TESO",
                "Alias": "ROL_TESO",
                "Value": "N"
    
              },
              {
                "Name": "ID_OR_NAME_TEXT",
                "Alias": "ID_OR_NAME_TEXT",
                "Value": ""
    
              },

              {
                "Name": "IND_CORREO",
                "Alias": "IND_CORREO",
                "Value": "S"
    
              },
             
            ]
          },
          "Data": []
        }
      }



      public setEmailInfo(action: Action) {

        let form: CtFormComponent = this.utilService.getComponentRef(action.conditionParams[0]);
        let tableAccesos: CtTableComponent = this.utilService.getComponentRef(action.conditionParams[1]);
        let correoInput: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[2]);



        this.subscriptions.push(this.getEmailParams(form,tableAccesos,correoInput).subscribe({
          next: (response: ApiResponseModel) => {
          },
          error: (err: any) => {
            this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
              true, 'Aceptar', 'Cancelar');
          }
        }));
      }

      private emailsArray(tableAccesos: CtTableComponent, correoInput: CtInputTextComponent): ADN_PLUS {
        let adn = new ADN_PLUS();
    
        if (tableAccesos) {

            let tableData = tableAccesos.getTableData();

            for (let i = 0; i < tableData.length; i++) {
                let row = tableData[i];
                if (row.getStringAttribute('C_USERS_PF_EMAIL'))
                  adn.setStringAttribute('C_EMAIL_' + i, row.getStringAttribute('C_USERS_PF_EMAIL'));
              }
        }
    
        return adn;
    }

    


      public getEmailParams(form: CtFormComponent, tableAccesos: CtTableComponent, correoInput:  CtInputTextComponent): Observable<any> {
        const requestData: any = this.setEmailParamsMetadata(form,tableAccesos,correoInput);
        return this.httpService.post(HttpService.ENDPOINT + '/api/process/PLANILLAS/SER_NOTIF_PAGO_PENDIENTE_SVA', requestData);
      }


      private setEmailParamsMetadata(form: CtFormComponent, tableAccesos: CtTableComponent, correoInput:  CtInputTextComponent): any {


        return {
          "Type": 1,
          "UserCode": "SVA",
          "Source": "SVA",
          "Conditions":
          {
            "Data": [
              {
                "Name": "NUM_PLANILLA",
                "Alias": "NUM_PLANILLA",
                "Value":  Number(this.numPlanilla) 
              },
              {
                "Name": "TIP_PLANILLA",
                "Alias": "TIP_PLANILLA",
                "Value":  form.getFormElementByModelId('TIPO_PLANILLA').getValue()
              },
              {
                "Name": "PER_COBRO",
                "Alias": "PER_COBRO",
                "Value":  this.perCobro
              },
              {
                "Name": "PERIODO",
                "Alias": "PERIODO",
                "Value":  form.getFormElementByModelId('PERIODO').getValue()
              },
              {
                "Name": "TOTAL",
                "Alias": "TOTAL",    
                "Value": this.totalAmount
              },
              {
                "Name": "CORREO_ELECTRONICO",
                "Alias": "CORREO_ELECTRONICO",    
                "Value": correoInput.getValue()
              },


              
            ]
          },
          "Data": [
                
            this.emailsArray(tableAccesos,correoInput)
                        
                 
          ]
        }
      }

      
      public setPresentarPlan(action: Action) {

        let numPatrono: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[0]);
        let docIdPatrono: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[1]);
        let tipPlanilla: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[2]);
        let tipoPresentacion: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[3]);
        let numComprobante: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[5]);

        this.numComprobante = numComprobante.getValue();
        if(this.numComprobante == null 
        || this.numComprobante == undefined
        || this.numComprobante === ''){
            this.plusAlertService.setCtDialogInfo('ERROR', 
            'primary', 'error', 'primary', 'Por favor, ingrese el número de comprobante',
            true, 'Aceptar', 'Cancelar');
            return false;
        }

        let numPlanilla: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[4]);

        this.subscriptions.push(this.getPresentarPlanParams(numPatrono, docIdPatrono,tipPlanilla,tipoPresentacion).subscribe({
          next: (response: ApiResponseModel) => {

            let data = response['Data']

            let numPlanilla = this.utilService.getStringAttribute('NUM_PLANILLA', data[0].ArrayEntities.List);

            this.storeService.setState('numPlanilla', Number(numPlanilla));

            this.numPlanilla = numPlanilla;

        },
          error: (err: any) => {
            this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
              true, 'Aceptar', 'Cancelar');
          }
        }));
      }

      public getPresentarPlanParams(numPatrono: CtInputTextComponent, docIdPatrono: CtInputTextComponent, tipPlanilla: CtInputTextComponent, tipoPresentacion:  CtInputTextComponent): Observable<any> {
        const requestData: any = this.setPresentarPlanMetadata(numPatrono, docIdPatrono,tipPlanilla,tipoPresentacion);
        return this.httpService.post(HttpService.ENDPOINT + '/api/process/SVA_PLANILLAS/SER_PRESENTAR_PLAN_SVA', requestData);
      }


      private setPresentarPlanMetadata(numPatrono: CtInputTextComponent, docIdPatrono: CtInputTextComponent, tipPlanilla: CtInputTextComponent, tipoPresentacion:  CtInputTextComponent): any {


        return {
          "Type": 1,
          "UserCode": "SVA",
          "Source": "SVA",
          "Conditions":
          {
            "Data": [
              {
                "Name": "NUM_PATRONO",
                "Alias": "NUM_PATRONO",
                "Value":  numPatrono.getValue()
        
              },
              {
                "Name": "DOC_IDENTIFICACION_PATRONO",
                "Alias": "DOC_IDENTIFICACION_PATRONO",
                "Value":  docIdPatrono.getValue()
    
              },
              {
                "Name": "TIP_PLANILLA",
                "Alias": "TIP_PLANILLA",
                "Value":  tipPlanilla.getValue()
              },
              {
                "Name": "TIP_PRESENTACION",
                "Alias": "TIP_PRESENTACION",
                "Value":  tipoPresentacion.getValue()
              },
              {
                "Name": "NUM_COMPROBANTE",
                "Alias": "NUM_COMPROBANTE",
                "Value":  this.numComprobante
              }
             
            ]
          },
          "Data": []
        }
      }


      


    /* -------------------- END CONTROLLER LOGIC ----------------- */
}
